export const setMeta = (dataDescription, dataKeywords, robots) => {
  let keyWords = document.querySelectorAll('meta[name="keywords"]')[0];
  let description = document.querySelectorAll('meta[name="description"]')[0];
  let robotsEl = document.querySelector('meta[name="robots"]');
  let documentFragment = document.createDocumentFragment();
  if (keyWords) {
    keyWords.remove();
  }
  if (dataKeywords || dataKeywords === "") {
    let metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content = dataKeywords;
    documentFragment.appendChild(metaKeywords);
  }

  if (description) {
    description.remove();
  }
  if (dataDescription || dataDescription === "") {
    let metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    metaDescription.content = dataDescription;
    documentFragment.appendChild(metaDescription);
  }

  if (robotsEl) {
    robotsEl.remove();
  }
  if (robots) {
    let metaDescription = document.createElement("meta");
    metaDescription.name = "robots";
    metaDescription.content = robots;
    documentFragment.appendChild(metaDescription);
  }

  document.getElementsByTagName("head")[0].appendChild(documentFragment);
};
